















import Vue from 'vue';

export default Vue.extend({
  name: 'twitter-icon',
  props: {
    color: {
      type: String,
      required: false,
      default: '#FFFFFF',
    },
  },
});
